var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBooth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.09 3.99H5.90999C4.39999 3.99 3.17999 5.21 3.17999 6.72V17.52C3.17999 19.03 4.39999 20.25 5.90999 20.25H18.09C19.6 20.25 20.82 19.03 20.82 17.52V6.72C20.82 5.21 19.6 3.99 18.09 3.99ZM19.58 17.63C19.58 18.44 18.92 19.09 18.12 19.09H5.88999C5.07999 19.09 4.42999 18.43 4.42999 17.63V6.6C4.42999 5.79 5.08999 5.14 5.88999 5.14H18.12C18.93 5.14 19.58 5.8 19.58 6.6V17.64V17.63Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.57 12.84H4.34998V14.11H19.57V12.84Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.01002 14.8H6.60001C6.48403 14.8 6.39001 14.894 6.39001 15.01V16.42C6.39001 16.536 6.48403 16.63 6.60001 16.63H8.01002C8.12599 16.63 8.22002 16.536 8.22002 16.42V15.01C8.22002 14.894 8.12599 14.8 8.01002 14.8Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooth);
export default __webpack_public_path__ + "static/media/booth.ac997cb33fe8875d599a565f2bf031b3.svg";
export { ForwardRef as ReactComponent };